import { BaseService } from "./base.service";
import { IErpDbCompany } from "models/ErpDbCompanyModel";
import AddDepartmentErpDbCompany from "models/Department/addDepartmentErpDbCompany";
import { TableFilterModel } from "models/TableFilterModel";
import {
	ErpDbCompanyDetailModel,
	IErpDbCompanyGridDetail,
} from "models/ErpDbCompanySummaryDetail";
import { ErpDatabase, IErpDatabaseGridDetail } from "models/OrganizationDetail";

class ErpDbCompanyServiceInternal extends BaseService {
	getErpDbCompanyList = async (): Promise<IErpDbCompany[]> =>
		this.callApi<IErpDbCompany[]>(`ErpDbCompany/GetErpDbCompanyList`, "GET");

	getUserErpDbCompanyList = async (): Promise<IErpDbCompany[]> =>
		this.callApi<IErpDbCompany[]>(
			`ErpDbCompany/GetUserErpDbCompanyList`,
			"GET"
		);

	getDepartmentErpDbCompanyList = async (
		departmentIds: number[]
	): Promise<IErpDbCompany[]> =>
		this.callApi<IErpDbCompany[]>(
			"ErpDbCompany/GetErpDbCompanyList",
			"POST",
			undefined,
			{ departmentIds }
		);

	saveDepartmentErpDbCompanyDetail = async (
		model: AddDepartmentErpDbCompany
	): Promise<number> =>
		this.callApi<number>(
			`DepartmentErpDbCompany/Save`,
			"POST",
			undefined,
			model
		);

	saveUpdateDepartmentInstances = async (
		model: AddDepartmentErpDbCompany
	): Promise<{
		departmentInstanceId: number;
		departmentErpDbCompanyId: number;
	}> =>
		this.callApi<{
			departmentInstanceId: number;
			departmentErpDbCompanyId: number;
		}>(`DepartmentErpDbCompany/SaveUpdateInstance `, "POST", undefined, model);

	deleteDepartmentErpDbCompanyDetail = async (
		departmentErpDbCompanyId: number
	): Promise<undefined> =>
		this.callApi<undefined>(
			`DepartmentErpDbCompany/Delete/${departmentErpDbCompanyId}`,
			"DELETE",
			undefined,
			undefined,
			true
		);

	getErpDbCompanyGridList = async (
		model: TableFilterModel
	): Promise<IErpDbCompanyGridDetail[]> =>
		this.callApi<IErpDbCompanyGridDetail[]>(
			`ErpDbCompany/GetErpDbCompanyGridList`,
			"POST",
			undefined,
			model
		);

	getErpDbCompanyDetail = async (
		erpDbCompanyId: number
	): Promise<ErpDbCompanyDetailModel> =>
		this.callApi<ErpDbCompanyDetailModel>(
			`ErpDbCompany/GetById/${erpDbCompanyId}`,
			"GET"
		);

	updateErpDbCompanyDetail = async (
		model: ErpDbCompanyDetailModel
	): Promise<number> =>
		this.callApi<number>(`ErpDbCompany/Update`, "PUT", undefined, model);

	getAllErpDbDatabaseGrid = async (): Promise<IErpDatabaseGridDetail[]> =>
		this.callApi<IErpDatabaseGridDetail[]>(
			`ErpDbCompany/GetAll`,
			"GET",
			undefined
		);

	saveUpdateErpDbDatabase = async (model: ErpDatabase[]): Promise<number> =>
		this.callApi<number>(`ErpDbCompany/SaveUpdate`, "POST", undefined, model);
}

export const ErpDbCompanyService = new ErpDbCompanyServiceInternal();
